export default __webpack_public_path__ + "static/media/KabelBd-Normal.59d7ce23.ttf";